import { useState } from 'react';
import spinners, { type SpinnerName } from 'cli-spinners';
import { useInterval } from './use_interval';

/**
 * Returns the current frame string for a spinner, advancing on each interval.
 * Pass `active: false` to pause the interval (e.g. once loading is done),
 * avoiding unnecessary re-renders.
 */
export const useSpinnerFrame = (
  spinnerName: SpinnerName = 'line',
  active = true,
  intervalMs?: number,
): string => {
  const spinner = spinners[spinnerName];
  const [frame, setFrame] = useState(0);
  const delay = active ? (intervalMs ?? spinner.interval) : null;
  useInterval(() => setFrame((f) => (f + 1) % spinner.frames.length), delay);
  return spinner.frames[frame];
};
